<script>
export default {
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div
    :class="[
      $style.block,
      secondary ? $style.secondary : null,
      white ? $style.white : null,
      transparent ? $style.transparent : null,
    ]"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<style lang="sass" module>
.block
  height: 100%
  padding: 24px 30px
  background: #F8F8F8
  -webkit-box-shadow: 0 3px 6px 0 rgba(197, 191, 200, 0.13)
  box-shadow: 0 3px 6px 0 rgba(197, 191, 200, 0.13)

.secondary
  background: var(--gray-2)

.white
  background: var(--white)

.transparent
  background: transparent
</style>
